import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=8c8b4ef2&"
import script from "./Admins.vue?vue&type=script&setup=true&lang=js&"
export * from "./Admins.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports